const STRAVA_CLIENT_ID = 15183;
const STRAVA_SCOPE = "profile:read_all,activity:read_all";
const AUTH_RETURN_TO_KEY = "activityviz_auth_return_to";

const isLocalHostname = (hostname: string) =>
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";

export const getStravaRedirectUri = (): string => {
  const configuredRedirectUri = import.meta.env.VITE_STRAVA_REDIRECT_URI;
  if (typeof configuredRedirectUri === "string" && configuredRedirectUri.trim().length > 0) {
    return configuredRedirectUri.trim();
  }

  const protocol = isLocalHostname(window.location.hostname) ? "http:" : "https:";
  return `${protocol}//${window.location.host}/stravaAuthComplete`;
};

export const rememberPostAuthDestination = (destination?: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  const nextDestination =
    destination || `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (
    !nextDestination ||
    nextDestination === "/" ||
    nextDestination.startsWith("/stravaAuthComplete")
  ) {
    window.sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
    return;
  }

  window.sessionStorage.setItem(AUTH_RETURN_TO_KEY, nextDestination);
};

export const consumePostAuthDestination = (fallback: string = "/dashboard"): string => {
  if (typeof window === "undefined") {
    return fallback;
  }

  const storedDestination = window.sessionStorage.getItem(AUTH_RETURN_TO_KEY);
  window.sessionStorage.removeItem(AUTH_RETURN_TO_KEY);

  if (!storedDestination || !isSafePostAuthDestination(storedDestination)) {
    return fallback;
  }

  return storedDestination;
};

const isSafePostAuthDestination = (destination: string): boolean => {
  if (!destination.startsWith("/")) {
    return false;
  }

  try {
    return new URL(destination, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
};

export const getStravaAuthUrl = (): string => {
  rememberPostAuthDestination();
  const params = new URLSearchParams({
    client_id: STRAVA_CLIENT_ID.toString(),
    response_type: "code",
    redirect_uri: getStravaRedirectUri(),
    scope: STRAVA_SCOPE,
  });

  return `https://www.strava.com/oauth/authorize?${params.toString()}`;
};
